import { render, staticRenderFns } from "./FormatReferrer.vue?vue&type=template&id=77973441&scoped=true&"
import script from "./FormatReferrer.vue?vue&type=script&lang=ts&"
export * from "./FormatReferrer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferrer.vue?vue&type=style&index=0&id=77973441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77973441",
  null
  
)

export default component.exports